import httpClient from '@/core/http/client.service';

const getMenuLinks = () => httpClient.get('api/v1/menu/hamburger?_format=json');

const getAppVersion = () => httpClient.get('api/v1/general/version?_format=json');

export default {
  getMenuLinks,
  getAppVersion,
};
